import { hide, show, toggle } from "slidetoggle";
const slideToggleDefaults = {
  miliseconds: 200,
  transitionFunction: 'linear',
};
const slideToggle = (el, opts = {}) => {
  toggle(el, { ...slideToggleDefaults, ...opts });
};
const slideUp = (el, opts = {}) => {
  hide(el, { ...slideToggleDefaults, ...opts });
};
const slideDown = (el, opts = {}) => {
  show(el, { ...slideToggleDefaults, ...opts });
};

export default class FaqFromPage extends HTMLElement {
	constructor() {
		super();
    this.init();
	}

  el = 'faq-from-page-item';


  openIndex = null;

  setOpenIndex(i) {
    this.openIndex = i;
    console.log()
    this.querySelectorAll(`.${this.el}__copy`).forEach((copyArea, copyAreaIndex) => {
      const parent = copyArea.closest(`.${this.el}`);
      if (copyAreaIndex === i) {
        slideDown(copyArea);
        parent.classList.add('js-open');
      }
      else {
        slideUp(copyArea);
        parent.classList.remove('js-open');
      }
    })
  }

  items = [];

  init() {
    this.innerHTML.split('-----').forEach((accordion, accordionIndex) => {
      const dom = document.createElement('html');
      dom.innerHTML = accordion;
      const header = dom.querySelector('h3');
      dom.querySelector('h3').remove();
      const copy = dom.querySelector('body').innerHTML;

      const item = this.item(
        header,
        copy,
        accordionIndex,
      );
      this.items.push(item);
    });

    this.innerHTML = '';

    this.items.forEach((item) => {
      this.append(item);
    });

    this.classList.remove('!hidden');
  }

  item(header, copy, index) {
    const item = document.createElement('div');
    item.classList.add(this.el);
    item.innerHTML = `
      <a href="#" class="${this.el}__header">
        <div>${header.innerHTML}</div>
        <div class="${this.el}__toggle">
        </div>
      </a>
      <div class="${this.el}__copy hidden rte">
        <div class="${this.el}__copy-inner">
          ${copy}
        </div>
      </div>
    `;

    item.querySelector('a').addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (index === this.openIndex) {
        this.setOpenIndex(null);
      } else {
        this.setOpenIndex(index);
      }
    });

    return item;
  }
}

export { FaqFromPage }
